<template>
	<sideNav :page-title="pageTitle"></sideNav>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { authInfo } from '@/api/auth';
	import sideNav from '../../components/sideNav.vue';

	const router = useRouter();
	const pageTitle = 'account';

	const generData = () => {
		authInfo().then((res) => {
			if(res.code === 200){
				if (res.data.authStatus == '1') {
					router.push({ path: '/verify/success' })
				}else{
					router.push({ path: '/verify/reselect' })
				}
			}
		})
	};
	
	onMounted(() => {
		generData()
	})
	
</script>

<style lang="scss" scoped>
	.verify-info{
		text-align: center;
		padding: 50px 0;
		overflow: hidden;
		h4{font-size: 18px; font-weight: bold; margin-bottom: 12px;}
		p{color: #666; margin-bottom: 3px;}
	}
	.verify-type{
		text-align: center;
		overflow: hidden;
		li{
			display: inline-block;
			vertical-align: top;
			border: 1px solid #ddd;
			margin: 0 16px;
			padding: 60px 30px 30px;
			width: 300px;
			cursor: pointer;
			h4{font-size: 18px; color: #333; margin-bottom: 16px;}
			p{
				height: 135px;
				text-align: left; 
				overflow: hidden;
				span{margin-bottom: 6px; line-height: 20px; position: relative; padding-left: 10px; display: block; color: #666; font-size: 12px;}
				span:before{content: "";width: 4px;height: 4px;background-color: #555; position: absolute;left: 0;top: 8px;}
			}
		}
		li:before{content: "";display: block;width: 68px;height: 67px;margin: 0 auto 24px;background: url(../../assets/images/auth.png) no-repeat;}
		li.per:before{background-position: -70px 0}
		li.ens:before{background-position: 0 0}
	}
	.tip-main{line-height: 22px;position: relative;padding-left: 30px; overflow: hidden;}

</style>